import { Badge } from '@/app/_components/ui/badge';
import { Button } from '@/app/_components/ui/button';
import { cn } from '@/app/_lib/utils';
import { User } from 'lucide-react';
import { forwardRef } from 'react';
import SidebarUserInfo from './sidebar-user-info';

type SidebarUserButtonProps = Omit<
  React.ComponentPropsWithoutRef<typeof Button>,
  'children' | 'variant'
> & {
  isCollapsed: boolean;
  email?: string | null;
  alias?: string | null;
  spend?: number | null;
};

const SidebarUserButton = forwardRef<HTMLButtonElement, SidebarUserButtonProps>(
  ({ isCollapsed, email, alias, spend, className, ...rest }, ref) => {
    return (
      <Button
        ref={ref}
        variant="ghost"
        className={cn('w-full h-auto p-2 bg-background border', className)}
        {...rest}
      >
        <Badge
          variant="secondary"
          className={`${
            isCollapsed ? '' : 'size-10'
          } p-0 flex items-center justify-center`}
        >
          <User />
        </Badge>
        {!isCollapsed && (
          <SidebarUserInfo email={email} alias={alias} spend={spend} />
        )}
      </Button>
    );
  },
);

SidebarUserButton.displayName = 'SidebarUserButton';

export default SidebarUserButton;
